import React from "react";
import './uploader.css'
function Uploader({changeInput}) {
  return (
    <div id="bodyUpladerItem">
      <div class="out-wrapDigital">
        <p class="headDigitalNode">Clique no botão e seleciona a imagem que irá enviar</p>
        <div class="in-wrapDigital">
          <label for="file" class="ui icon buttonUpladerIcon">
            Selecionar a imagem
          </label>
          <p class="f-name"></p>
          <input onChange={(e)=>changeInput(e)} type="file" id="file" />
        </div>
      </div>
    </div>
  );
}
export default Uploader;
